import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import { updateProspectService } from '@hc-frontend/services';

import type { UpdateProspectAnalyticsIdentifierRepository } from '../../domain';

export function updateProspectAnalyticsIdentifierAdapterFactory({
  baseURL,
}: {
  baseURL: string;
}): UpdateProspectAnalyticsIdentifierRepository {
  return async (parameters) => {
    try {
      const response = await updateProspectService(baseURL, parameters);

      if (response.result !== 'success') {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToUpdateProspectAnalyticsIdentifier',
              rootCause: new Error('Failed to update prospect step.'),
            },
          ],
        });
      }

      return createSuccessOperationResult(undefined);
    } catch (error) {
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToUpdateProspectAnalyticsIdentifier',
            rootCause: error as Error,
          },
        ],
      });
    }
  };
}
